
(() => {
  const loader = document.querySelector('[data-veloura-loader]');
  if (!loader) return;

  const hide = () => {
    loader.hidden = true;
  };
  const reveal = () => {
    loader.classList.add('is-ready');
    window.setTimeout(hide, 320);
  };

  try {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const seen = window.sessionStorage.getItem('veloura-intro-seen');
    if (reduceMotion || seen) {
      hide();
      return;
    }
    window.sessionStorage.setItem('veloura-intro-seen', '1');
  } catch (_error) {
    hide();
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }

  // The intro is decorative and must never block shopping.
  window.setTimeout(reveal, 900);
})();

(() => {
  const arrangeGuideMenu = () => {
    const guideLink = document.querySelector('header .menu-list__link[href="/pages/size-fit-guide"]');
    const sleepwearLink = document.querySelector('header .menu-list__link[href="/collections/sleepwear"]');
    const guideItem = guideLink?.closest('.menu-list__list-item');
    const sleepwearItem = sleepwearLink?.closest('.menu-list__list-item');
    const menu = guideItem?.parentElement;

    if (!guideItem || !sleepwearItem || !menu) return;

    if (guideItem.getAttribute('slot') === 'overflow') guideItem.removeAttribute('slot');
    if (sleepwearItem.getAttribute('slot') !== 'overflow') sleepwearItem.setAttribute('slot', 'overflow');

    if (menu.dataset.velouraGuideMenuReady) return;
    menu.dataset.velouraGuideMenuReady = 'true';

    const observer = new MutationObserver(() => window.requestAnimationFrame(arrangeGuideMenu));
    observer.observe(menu, { attributes: true, subtree: true, attributeFilter: ['slot'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.requestAnimationFrame(arrangeGuideMenu), { once: true });
  } else {
    window.requestAnimationFrame(arrangeGuideMenu);
  }
})();

